import { ClaimsService } from './../../../../../core/services/claims.service';
import { DocumentViewerComponent } from './../../../../../shared/components/document-viewer/document-viewer.component';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { HttpUrlEncodingCodec } from '@angular/common/http';
import { Bucket } from 'src/app/core/const/bucket';

@Component({
  selector: 'app-claim-documents-list',
  templateUrl: './claim-documents-list.component.html',
  styleUrls: ['./claim-documents-list.component.scss'],
  providers: [HttpUrlEncodingCodec]
})
export class ClaimDocumentsListComponent implements OnInit {

  selectedDocumentType: any;
  documentsPresent = false;
  constructor(public dialogRef: MatDialogRef<ClaimDocumentsListComponent>, public dialog: MatDialog,
    private httpUrlEncodingCodec: HttpUrlEncodingCodec, private claimsService: ClaimsService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.data.claimDocs.forEach((element: any) => {
      if (element.documents) {
        if (element.documents.length > 0) {
          this.documentsPresent = true;
        }
      }
    });
  }
 
  modifiedName(name: string): string {
    // Remove "TPA_Email_" from the beginning of the name
   return name.replace(/TPA_Email_/g, "TPA Document_").replace(/%2F/g, "TPA_Document_");
  }

  addDocument(event: any, selectedDocumentType: any) {
    const doc = selectedDocumentType;
    // Single Dot
    // JPEG, TIFF and PDF
    // Not more that 2 MB


    for (const file of event.target.files) {

      if (file.size > 15000000) {
        Swal.close();
        Swal.fire('', 'Cannot upload document with name ' + file.name + '. File size more than 15MB.', 'error');
        return;
      }

      if (file.name.indexOf('.') !== file.name.lastIndexOf('.')) {
        Swal.close();
        Swal.fire('', 'Cannot upload document with name ' + file.name + '. There can only be one period in file name.', 'error');
        return;
      }
      const validExtensions = ["jpg", "jpeg", "png", "tiff", "pdf", "xls", "xlsx", "xlsb", "doc", "docx", "csv", "zip"];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (validExtensions.indexOf(fileExtension) === -1) {
        Swal.close();
        Swal.fire('', 'Cannot upload document with name ' + file.name + '. Supported types are .pdf, .jpeg, .jpg, .png, .tiff, .xls, .xlsx, .xlsb, .doc, .docx, .csv, and .zip', 'error');
        return;
      }
    }


    if (event.target.files.length === 0) {
      return;
    }


    Swal.fire({ title: 'Uploading Document/s' });
    Swal.showLoading();

    for (const file of event.target.files) {
      const reader = new FileReader();
      let document: any = {
        name: '',
        type: '',
        isAdded: false,
        file: '',
        canDelete: false,
        extension: ''
      };
      reader.readAsDataURL(file);
      reader.onload = function () {
        document.name = file.name;
        document.type = doc.documentType;
        document.isAdded = false;
        document.file = reader.result;
        document.canDelete = true;
        document.extension = file.name.split('.').pop().toLowerCase();
        if (doc.documents) {
          doc.documents.push(document);
        } else {
          doc.documents = [];
          doc.documents.push(document);
        }
      };
      reader.onerror = function (error) {
      };
    }

    Swal.close();
    Swal.fire('Document/s uploaded successfully!', '', 'success');
    this.selectedDocumentType = null;
    this.documentsPresent = true;
  }

  close() {
    this.dialogRef.close(JSON.stringify(this.data.claimDocs));
  }

  deleteDocument(docType: string, docName: string) {
    const claimDocuments = this.data.claimDocs.filter((doc: any) => doc.documentType === docType)[0];
    let deleteIndex = -1;
    claimDocuments.documents.forEach((document: any) => {
      if (document.name === docName) {
        deleteIndex = claimDocuments.documents.indexOf(document);
      }
    });
    if (deleteIndex !== -1) {
      claimDocuments.documents.splice(deleteIndex, 1);
      if (claimDocuments.documents.length === 0) {
        claimDocuments.documents = null;
      }
      this.data.claimDocs.filter((doc: any) => doc.documentType === claimDocuments.documentType).map((doc: any) => doc.documents = claimDocuments.documents);
    }
  }

  downloadReport(fileUrl: any) {
    // window.open(fileUrl);
    if (fileUrl.includes('base64')) {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', fileUrl);
    link.setAttribute('download', 'Documents');
    document.body.appendChild(link);
    link.click();
    link.remove();
    }else{
    Swal.showLoading();
     const url = this.httpUrlEncodingCodec.decodeValue(fileUrl);
    const key = url.substr((url.indexOf('/', 10) + 1));
       this.claimsService.getPreSignedUrlByKey(Bucket.group, key).subscribe((res:any)=>{
           Swal.close();
            if(res.body){
           window.open(res.body);
         }
       },(err: any) => {
   Swal.close();
   Swal.fire('', err.error ? err.error : err.message, 'error');
 })
    
    // this.claimsService.fetchDocument(this.httpUrlEncodingCodec.decodeValue(fileUrl)).subscribe(
    //   (res: any) => {
    //     Swal.close();
    //     if (res.body.docType === 'pdf') {
    //       this.dialog.open(DocumentViewerComponent, { width: '80vw', data: { imageSource: `${res.body.docBaseSF}` } });
    //     } else {
    //       Swal.close();
    //       const link = document.createElement('a');
    //       link.setAttribute('target', '_blank');
    //       link.setAttribute('href', `data:application/${res.body.docType};base64,${res.body.docBaseSF}`);
    //       link.setAttribute('download', res.body.docName);
    //       document.body.appendChild(link);
    //       link.click();
    //       link.remove();
    //     }
    //   },
    //   (err: any) => {
    //     Swal.close();
    //     Swal.fire('', err.error.message ? err.error.message : err.message, 'error');
    //   }
    // );
  }
}

}
